/** Shared Dayvise identity. Each application ships the canonical /brand assets. */
export function DayviseBrand() {
  return (
    <span role="img" aria-label="Dayvise" style={{ display: "inline-flex", flexShrink: 0 }}>
      <style href="dayvise-brand" precedence="dayvise">{`
        .dayvise-brand-image { width: 158px; height: auto; display: block; }
        .dayvise-brand-light { display: none; }
        [data-dayvise-scheme="light"] .dayvise-brand-dark { display: none; }
        [data-dayvise-scheme="light"] .dayvise-brand-light { display: block; }
      `}</style>
      <img className="dayvise-brand-image dayvise-brand-dark" src="/brand/dayvise-lockup-dark.svg" alt="" width={610} height={144} />
      <img className="dayvise-brand-image dayvise-brand-light" src="/brand/dayvise-lockup-light.svg" alt="" width={610} height={144} />
    </span>
  );
}
